import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Documento',
    path: 'documento/:entidade?/:entidadeId/:utlTipoFornecimentoId',
    name: 'documento',
    component: () => import('@/views/gestao/documento/Index.vue'),
    goesToMenu: false,
    meta: {
      permissions: [EPermissoes.CadastroProduto],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusao de Documento',
    path: 'documento/incluir/:entidade?/:entidadeId/:utlTipoFornecimentoId',
    parent: 'documento',
    name: 'documentoinsert',
    component: () => import('@/views/gestao/documento/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'documento',
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Edicao de Documento',
    path: 'documento/editar/:entidade/:entidadeId/:id/:utlTipoFornecimentoId',
    parent: 'documento',
    name: 'documentoupdate',
    component: () => import('@/views/gestao/documento/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'documento',
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  }
];
